import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getPitchStatusColor = (status: string) => {
  switch (status) {
    case "SUBMITTED":
      return "bg-sidebar text-secondary-foreground"
    case "Approved":
      return "bg-emerald-400"
    case "COMMISSIONED":
      return "bg-emerald-600"
  }
}
export const getStoredLocale = () => localStorage.getItem("egab_locale") || "en"

export const formatDate = (date: any) => {
  const storedLocale = getStoredLocale()
  return new Date(date).toLocaleDateString(
    storedLocale === "ar" ? "ar-EG" : undefined,
    {
      year: "numeric",
      month: "short",
      day: "numeric",
    }
  )
}

export function formatDateTime(date: string) {
  const storedLocale = getStoredLocale()
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return new Intl.DateTimeFormat(storedLocale === "ar" ? "ar-EG" : "en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: userTimeZone,
  }).format(new Date(`${date}Z`))
}

export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return "0 Bytes"

  const k = 1024
  const units = ["Bytes", "KB", "MB", "GB", "TB", "PB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const value = bytes / Math.pow(k, i)

  return `${parseFloat(value.toFixed(decimals))} ${units[i]}`
}

export const uniqueById = <T extends { id: number }>(items: T[]): T[] => {
  return Array.from(new Map(items.map((item) => [item.id, item])).values())
}

export const handleNumberKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
    "Home",
    "End",
  ]

  if (allowedKeys.includes(e.key)) {
    return
  }

  // block anything that isn't a digit
  if (!/^[0-9]$/.test(e.key)) {
    e.preventDefault()
  }
}

export const handleNumberPaste = (
  e: React.ClipboardEvent<HTMLInputElement>
) => {
  const pasted = e.clipboardData.getData("text")
  if (!/^[0-9]*$/.test(pasted)) {
    e.preventDefault()
  }
}

export function countryCodeToFlag(code) {
  return code
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join("")
}

export function lowerFirst(value: string) {
  return value.charAt(0).toLowerCase() + value.slice(1)
}